import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { CardBody, CardTitle } from "reactstrap"

export default function Product(props) {
  const { mainImage, name, price, category, subcategory, slug } = props.product

  return (
    <ProductCard tag="Link" to={`/product/${slug}`} className="mb-2 border-0">
      <GatsbyImage image={getImage(mainImage)} loading="auto" alt={name} />
      <CardBody className="px-0 text-default">
        <CategoryLink category={category} subcategory={subcategory} />
        <CardTitle tag="h6" className="mb-1 font-weight-bold text-truncate">
          {name}
        </CardTitle>
        <span>
          {(price / 100).toLocaleString("de", { minimumFractionDigits: 2 })} €
        </span>
      </CardBody>
    </ProductCard>
  )
}

const CategoryLink = ({ category, subcategory }) => {
  if (subcategory)
    return (
      <small className=" mb-1 text-muted text-truncate">
        {subcategory.map((category, i) => {
          if (i === 0) return category.name
          else return " | " + category.name
        })}
      </small>
    )
  if (category)
    return (
      <small className=" mb-1 text-muted text-truncate">{category.name}</small>
    )
  return null
}

const ProductCard = styled(Link)`
  color: ${({ theme }) => theme.textDefault};
  :hover {
    color: ${({ theme }) => theme.textDefault} !important;
    text-decoration: none !important;
  }
  img {
    border-radius: ${({ theme }) => theme.borderRadius};
  }
`
